import React from "react";
import { withTheme } from "styled-components/native";
import { string as yupString, object as yupObject, ref as yupRef } from "yup";
import { defineMessages } from "react-intl";
import { BaseCenteredLogoPage, Button, Icon, FormPasswordField, Form, ToastContext } from "cci-component";
import { resetPasswordMutation } from "cci-logic";
import { withRouter } from "cci-utility";

const messages = defineMessages({
  newPassword: {
    id: "newPassword",
    defaultMessage: "New password"
  },

  confirmPassword: {
    id: "confirmPassword",
    defaultMessage: "Confirm password"
  },

  passwordsDontMatch: {
    id: "passwordsDontMatch",
    defaultMessage: "Passwords don't match, please try again"
  },

  resetPassword: {
    id: "resetPassword",
    defaultMessage: "Reset Password"
  },
});

/**
 * Page that the user sees when clicking the link that they receive to reset their password.
 */
const ResetPasswordPage = ({ theme, history, match }) => (
  <BaseCenteredLogoPage>
    <ToastContext.Consumer>
      {toast => (
        <Form
          showMessage={toast.show}
          mutation={{
            mutation: resetPasswordMutation,
            context: {
              routeToLogin: () => history.replace("/")
            },
            variables: { token: match.params.token }
          }}
          validationSchema={yupObject().shape({
            password: yupString().required().matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/, "invalidPasswordFieldError"),
            confirmPassword: yupString().required().oneOf([yupRef("password"), null], "passwordsDontMatch")
          })}
        >
          {({handleSubmit, pristine, submitting}) => (
            <React.Fragment>
              {/* Password field */}
              <FormPasswordField
                name="password"
                leftComponent={
                  <Icon
                    name="lock"
                    color={theme.fieldIconColor}
                    iconSize={20}
                    style={{marginLeft: 10}}
                  />
                }
                margins="30px 0 0 0"
                returnKeyType="next"
                placeholder={messages.newPassword}
                onSubmitEditing={handleSubmit}
              />

              {/* Confirm Password field */}
              <FormPasswordField
                name="confirmPassword"
                leftComponent={
                  <Icon
                    name="lock"
                    color={theme.fieldIconColor}
                    iconSize={20}
                    style={{marginLeft: 10}}
                  />
                }
                margins="30px 0 0 0"
                returnKeyType="go"
                placeholder={messages.confirmPassword}
                onSubmitEditing={handleSubmit}
              />

              {/* Reset Password button */}
              <Button
                title={messages.resetPassword}
                width={200}
                height={60}
                margins="30px 0 0 0"
                alignSelf="center"
                disabled={pristine || submitting}
                onPress={handleSubmit}
              />
            </React.Fragment>
          )}
        </Form>
      )}
    </ToastContext.Consumer>
  </BaseCenteredLogoPage>
);

export default withRouter(withTheme(ResetPasswordPage));
